export var PartitionType;
(function (PartitionType) {
    PartitionType["DATE"] = "DATE";
    PartitionType["RANGE"] = "RANGE";
})(PartitionType || (PartitionType = {}));
//# sourceMappingURL=warehouse.js.map